import { SideBar } from '../sideBar';
import { menuKeys } from './config';

export const Sider = () => {
  return <SideBar menuKeys={menuKeys} />;
};
